import React from "react";
import { Flex, Modal, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const { Text } = Typography;

/**
 * Rechazar una versión en revisión: **es sólo una confirmación, como Aprobar**, sin motivo
 * (Diseño, 2026-10-01, xcons-docs#461). Los cambios vuelven a borrador para seguir
 * trabajándolos, y el rechazo queda en el historial.
 *
 * Vive aparte porque se rechaza desde dos lugares: la revisión de cambios sobre un
 * producto publicado y el formulario de un alta en revisión.
 */
export const ModalDeRechazo: React.FC<{
  open: boolean;
  ejecutando: boolean;
  onRechazar: () => Promise<unknown>;
  onCancel: () => void;
}> = ({ open, ejecutando, onRechazar, onCancel }) => (
  <Modal
    open={open}
    title={
      // El mismo ícono de alerta que usan los Modal.confirm de antd.
      <Flex align="center" gap={12}>
        <WarningOutlined style={{ color: "#faad14", fontSize: 22 }} />
        ¿Querés rechazar estos cambios?
      </Flex>
    }
    okText="Sí, rechazar"
    cancelText="Cancelar"
    confirmLoading={ejecutando}
    onOk={() => void onRechazar()}
    onCancel={onCancel}
  >
    <Text>Los cambios del producto volverán a estado en borrador.</Text>
  </Modal>
);
